module.exports = __webpack_public_path__ + "static/img/image_picture.5fc2969.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/image_picture.png
// module id = LRvd
// module chunks = 0